import React, { useState } from 'react';
import moment from 'moment';
import toast from 'react-hot-toast';
import { Modal as SimpleModal } from '@/components/custom/modal/modal';
import usePermission from '@/hooks/usePermission';

export function ReportTopBar({ children, lastUpdatedAt, onDownload }) {
  const [showModal, setShowModal] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const canDownload = usePermission('Download de relatórios', 'Relatórios');

  const handleDownload = async () => {
    setIsDownloading(true);
    try {
      await onDownload();
      setShowModal(false);
    } catch (error) {
      toast.error('Erro ao baixar o relatório');
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <>
      <div className="report__filter report__filter--space">
        <div className="flex items-center gap-3">{children}</div>

        <div className="flex items-center gap-4">
          {lastUpdatedAt && <span className="text-xs text-neutral-darker">Última atualização em {moment(lastUpdatedAt).format('DD/MM/YYYY [às] HH:mm')}</span>}

          {canDownload && (
            <button
              type="button"
              className="btn btn--outline"
              onClick={() => setShowModal(true)}
              disabled={isDownloading}
            >
              {isDownloading ? 'Baixando...' : 'Download do relatório'}
            </button>
          )}
        </div>
      </div>

      <SimpleModal
        show={showModal}
        onClose={() => setShowModal(false)}
      >
        <div className="flex flex-col items-center text-center">
          <h3 className="modal__dialog-title">Atenção!</h3>
          <p className="u-text-neutral-dark">
            O relatório será exportado em <strong>Excel</strong> e contém <strong>dados sensíveis</strong>. O uso e o compartilhamento dessas informações são de sua inteira responsabilidade, devendo estar em conformidade com as normas de segurança e
            privacidade.
          </p>
          <p className="u-text-neutral-dark">Clique em &quot;Confirmar&quot; para prosseguir com o download.</p>
          <div className="form__col">
            <button
              onClick={handleDownload}
              className={`btn btn--primary btn--full ${isDownloading ? 'disabled' : ''}`}
              type="button"
              disabled={isDownloading}
            >
              {isDownloading ? 'Baixando...' : 'Confirmar'}
            </button>
          </div>
        </div>
      </SimpleModal>
    </>
  );
}
